export { renderImage_unstable as renderImage } from '@fluentui/react-image';
